import { render } from "./BMyTicketReleaseDateDisp.vue?vue&type=template&id=eb19a586&scoped=true"
import script from "./BMyTicketReleaseDateDisp.vue?vue&type=script&lang=js"
export * from "./BMyTicketReleaseDateDisp.vue?vue&type=script&lang=js"

import "./BMyTicketReleaseDateDisp.vue?vue&type=style&index=0&id=eb19a586&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eb19a586"

export default script